import { useDictionary } from './useDictionary';
import type { Document } from '@/shared/types';

const useHelpDictionary = () => {
  const {
    data: helpData,
    isLoading: isHelpLoading,
    error: helpError,
  } = useDictionary<Document[]>({
    dictionaryName: 'help',
  });

  return {
    helpData,
    isHelpLoading,
    helpError,
  };
};

export { useHelpDictionary };
